import moment from "moment";
import Header from "../layout/Header";
import Sidebar from "../layout/Sidebar";
import Loader from "../components/other/Loader";
import NoRecord from "../components/other/NoRecord";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { pipViewDate2 } from "../utils/pip";
import { useNavigate, useLocation } from "react-router-dom";
import ReactPagination from "../components/reactPagination";
import PaginationDropdown from "../components/PaginationDropdown";
import { fetchNotificationDetail } from "../redux/action/authAction";

const NotificationDetail = () => {
  const { messageDetail } = useLocation()?.state || {};
  console.log({ messageDetail });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isToggle, notificationDetailList, isLoading } = useSelector(
    (state) => state.authReducer
  );

  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUserPerPages] = useState(5);
  const [filterValue, setFilterValue] = useState("");
  const [selectedDate, setSelectedDate] = useState("");

  useEffect(() => {
    dispatch(
      fetchNotificationDetail({
        payload: { notification_id: messageDetail?.notification_id },
      })
    );
  }, []);

  const displayData =
    filterValue == ""
      ? notificationDetailList
      : filterValue == "high"
      ? [...notificationDetailList].sort(
          (a, b) => a.report_count - b.report_count
        )
      : filterValue == "high"
      ? [...notificationDetailList].sort(
          (a, b) => b.report_count - a.report_count
        )
      : filterValue == "new"
      ? [...notificationDetailList].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        )
      : filterValue == "date"
      ? selectedDate == ""
        ? notificationDetailList
        : notificationDetailList.filter((user) => {
            console.log(
              user,
              moment.utc(user?.created_at).format("YYYY-MM-DD"),
              "===",
              moment.utc(selectedDate).format("YYYY-MM-DD")
            );
            const userDate =
              moment.utc(user?.created_at).format("YYYY-MM-DD") ==
              moment.utc(selectedDate).format("YYYY-MM-DD");
            return userDate;
          })
      : notificationDetailList;

  const paginatedUserReport = displayData?.slice(
    currentPage * usersPerPage,
    (currentPage + 1) * usersPerPage
  );

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  if (isLoading) {
    return <Loader />;
  }

  console.log("filterValue", { filterValue });

  return (
    <>
      <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
        <Sidebar />
        <div class="ct_right_content">
          <Header />

          <div class="ct_inner_dashbaord_main">
            <div class="row ">
              <div class="col-xxl-12 col-xl-12 mb-4 mb-xl-0 ">
                <div class="">
                  <div class="">
                    <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                      <ul class="d-flex align-items-center gap-2 mb-0">
                        <li>
                          {" "}
                          <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            Notification User List
                          </h4>
                        </li>
                        <li>
                          {" "}
                          <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            <i class="bi bi-dot"></i>
                          </h4>
                        </li>
                        <li>
                          {" "}
                          <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            {notificationDetailList.length}{" "}
                            {notificationDetailList.length <= 1
                              ? "User"
                              : "Users"}{" "}
                          </h4>
                        </li>
                      </ul>
                    </div>
                    <div className="ct_white_bg ct_orange_4_top_border mt-4">
                      <div>
                        <h4 className="ct_fs_20 ct_fw_700 mb-2">Title</h4>

                        <p className="mb-0">
                          {messageDetail?.notification_title ?? ""}
                        </p>
                      </div>
                      <div className="mt-3">
                        <h4 className="ct_fs_20 ct_fw_700 mb-2">Message</h4>

                        <p className="mb-0">
                          {messageDetail?.notification_message ?? ""}
                        </p>
                      </div>
                      <div className="mt-3">
                        <p className="ct_fs_20 ct_fw_700 mb-2">
                          Sagment : Value{" "}
                        </p>
                        <p className="mb-0 text-capitalize">
                          {`${messageDetail?.segment ?? ""} : ${
                            messageDetail?.segment_value
                          }`}
                        </p>
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table ct_custom_table ct_verticle_midddle_table123">
                        <thead>
                          <tr>
                            <th>S.No.</th>
                            <th>User Name</th>
                            <th>Send At</th>
                            <th>Status</th>
                          </tr>
                        </thead>

                        <tbody>
                          {paginatedUserReport &&
                          paginatedUserReport.length !== 0 ? (
                            paginatedUserReport.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    <div class="d-flex align-items-center gap-2">
                                      <div>
                                        <h5 class="ct_fs_16  ct_fw_700 mb-0">
                                          {item?.user_data?.name ?? ""}
                                        </h5>
                                      </div>
                                    </div>
                                  </td>

                                  <td>
                                    <div>
                                      <p class="mb-1 ct_fw_600 ct_fs_16 ct_orange_text">
                                        {" "}
                                      </p>
                                      <p class="mb-0 ct_fw_600 ct_fs_16">
                                        <span>
                                          {" "}
                                          {pipViewDate2(item?.sent_at)}
                                        </span>{" "}
                                      </p>
                                    </div>
                                  </td>

                                  <td>
                                    <div>
                                      <p
                                        className={`mb-0 ct_fw_600 ct_fs_16 ct_fw_600 text-capitalize`}
                                      >
                                        {item?.status}
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={11}>
                                <NoRecord />
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {paginatedUserReport && paginatedUserReport?.length != 0 && (
              <>
                <div className="d-flex justify-content-between align-items-center mt-4">
                  <div>
                    <PaginationDropdown
                      onChange={(val) => {
                        setUserPerPages(val);
                        setCurrentPage(0);
                      }}
                    />
                  </div>
                  <div>
                    <ReactPagination
                      pageCount={Math.ceil(
                        notificationDetailList?.length / usersPerPage
                      )}
                      onPageChange={handlePageClick}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default NotificationDetail;
